import { useState } from 'react';
import { DialogContent } from '@mui/material';
import useCurrentTerminal from '@/Hooks/useCurrentTerminal';
import ApplicationSpinner from '@/Infrastructure/Components/Loading/ApplicationSpinner';
import { useFetchDispatchEventsQuery } from '@api/Trinium/Endpoints/DispatchEvent';
import DispatchEventDataGrid from '@components/DataGrid/DispatchEvent/Grid';
import ApplicationModal from '@components/Modals/ApplicationModal';
import LegOrderHeader from '@components/Modals/Headers/LegOrderHeader';
import { ViewDispatchEventsProps } from './types';

import styles from './DispatchEvents.module.css';

export default function Modal({ legId, eventType }: ViewDispatchEventsProps) {
	const [isOpen, setIsOpen] = useState(true);
	const { number: terminalNumber } = useCurrentTerminal();
	const title = `View Dispatch Events${eventType ? `: ${eventType}` : ''}`;

	const { data: dispatchEvents, isFetching: dispatchEventListLoading } = useFetchDispatchEventsQuery(
		{ terminalNumber: terminalNumber, id: legId },
		{
			refetchOnMountOrArgChange: true
		}
	);

	return (
		<ApplicationModal
			isOpen={isOpen}
			onClose={() => {
				setIsOpen(false);
			}}
			title={title}
		>
			<LegOrderHeader
				terminalNumber={terminalNumber}
				legId={legId}
			/>

			<DialogContent className={styles['event-content']}>
				{dispatchEventListLoading ? (
					<ApplicationSpinner />
				) : (
					<DispatchEventDataGrid
						eventType={eventType}
						rows={dispatchEvents ?? []}
					/>
				)}
			</DialogContent>
		</ApplicationModal>
	);
}
